
  import { defineComponent, toRefs } from 'vue';
  import { Button } from '@/ui/components/Button';
  import { ScheduleFormProps } from '@/ui/components/schedule/scheduleFormProps';
  import { useValidation } from '@/ui/concerns';
  import { validate } from '@/entities/schedule';
  import ScheduleFormFields from '@/ui/components/schedule/ScheduleFormFields.vue';
  import { useSchedule } from '@/ui/concerns/schedule/useSchedule';

  export default defineComponent<ScheduleFormProps>({
    components: {
      Button,
      ScheduleFormFields,
    },
    props: [
      'userSelectOptions',
      'entityItemOptions',
      'checklistOptions',
      'submitButtonLabel',
      'sendRecordTask',
    ],
    setup(props, ctx) {
      const {
        userSelectOptions,
        sendRecordTask,
      } = toRefs(props);

      const {
        record,
      } = useSchedule();

      const {
        validationErrors,
        hasNoValidationErrors,
        showValidationErrors,
      } = useValidation(validate, record, sendRecordTask.value.state);

      const handleSubmit = () => {
        showValidationErrors.value = true;
        if (hasNoValidationErrors.value) {
          sendRecordTask.value.run();
        }
      };

      const updateUserOptions = () => {
        ctx.emit('update-user-options');
      };

      return {
        userOptions: userSelectOptions,
        entityOptions: props.entityItemOptions,
        validationErrors,
        hasNoValidationErrors,
        showValidationErrors,
        submitLabel: props.submitButtonLabel,
        sendRecord: sendRecordTask,
        handleSubmit,
        updateUserOptions,
      };
    },
  });
